import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { PostCard, PostCardSkeleton } from "@/features/feed/components/post-card";
import { usePost } from "@/features/feed/hooks/use-post";

export function PostPage() {
	const { obra: obraKey, postId } = useParams();
	const postQuery = usePost(postId);
	const feedPath = `/${obraKey}/feed`;

	if (postQuery.isPending) {
		return (
			<div className="post-page">
				<PostCardSkeleton />
			</div>
		);
	}

	if (postQuery.isError || !postQuery.data) {
		return (
			<Card className="card-narrow">
				<CardContent className="card-state">
					<p>Relato não encontrado.</p>
					<Button asChild variant="outline">
						<Link to={feedPath}>
							<ArrowLeft />
							Voltar para o feed
						</Link>
					</Button>
				</CardContent>
			</Card>
		);
	}

	return (
		<div className="post-page">
			<Button asChild variant="ghost" size="sm" className="post-page__back">
				<Link to={feedPath}>
					<ArrowLeft />
					Voltar para o feed
				</Link>
			</Button>
			<PostCard post={postQuery.data} defaultCommentsOpen />
		</div>
	);
}
